import "./App.css";
import React from "react";
import Nav from "./components/Nav";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import UploadTopics from "./components/UploadTopics";
import UploadQuestions from "./components/UploadQuestions";
import ViewTopics from "./components/ViewTopics";
import ViewQuestions from "./components/ViewQuestions";
import Header from "./components/Header";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import Loader from "./components/Loader";
import MyTeacherStats from "./components/MyTeacherStats";
import IndiaAgiStats from "./components/IndiaAgiStats";

function App() {
  const { user, isAuthenticated } = useAuth0();
  const [loading, setLoading] = useState(false);
  return (
    <div>
      <Loader loading={loading} />
      <Header user={user} isAuthenticated={isAuthenticated} />
      <Router>
        <Nav isAuthenticated={isAuthenticated} />
        <Routes>
          <Route
            path="/upload-topics"
            element={
              <UploadTopics
                isAuthenticated={isAuthenticated}
                loading={loading}
                setLoading={setLoading}
              />
            }
          />
          <Route
            path="/upload-questions"
            element={
              <UploadQuestions
                isAuthenticated={isAuthenticated}
                loading={loading}
                setLoading={setLoading}
              />
            }
          />
          <Route
            path="/view-topics"
            element={<ViewTopics isAuthenticated={isAuthenticated} />}
          />
          <Route
            path="/view-questions"
            element={<ViewQuestions isAuthenticated={isAuthenticated} />}
          />
          <Route
            path="/my-teacher-stats"
            element={<MyTeacherStats isAuthenticated={isAuthenticated} />}
          />
          <Route
            path="/india-agi-stats"
            element={<IndiaAgiStats isAuthenticated={isAuthenticated} />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
